/**
 * Bilder werden IM BROWSER verkleinert, bevor sie hinausgehen.
 *
 * EINE Stelle für zwei Wege: den Dateireiter im Auftrag und die Übernahme der
 * alten Ablage. Stand bis .79 in `Dateien.tsx`; die Übernahme hätte eine
 * zweite Fassung gebraucht, und zwei Fassungen laufen beim ersten Nachtrag
 * auseinander.
 *
 * Der Server verkleinert ein zweites Mal, auf `bilder.kantenlaenge` (2000).
 * Hier dieselbe Zahl: ein Bild, das der Browser auf 1600 kürzt, kommt am
 * Server nie mehr auf 2000 - dann wäre der Schlüssel eine Behauptung.
 */
const MAX_KANTE = 2000;
const JPEG_GUETE = 0.85;

/**
 * Ein Bild auf 2000 Pixel längste Kante bringen.
 *
 * DREI AUSNAHMEN, ALLE AUS DEM BESTAND:
 *   1. PDF geht UNVERÄNDERT durch. Die Verkleinerung zeichnet auf ein
 *      Zeichenfeld; aus der ausgefüllten Checkliste würde ein leeres Bild.
 *   2. Kann der Browser das Bild nicht decodieren (HEIC vom iPhone), geht die
 *      Originaldatei durch, MIT ihrem eigenen Typ.
 *   3. Wirft das Zeichenfeld, ebenfalls das Original.
 *
 * 2000 Pixel, weil das Massband darauf noch lesbar ist und der Rückweg über
 * ein Mobilfunknetz klein bleibt.
 */
export async function verkleinern(datei: File): Promise<File> {
  if (datei.type === 'application/pdf' || /\.pdf$/i.test(datei.name)) return datei;
  if (!/^image\//.test(datei.type)) return datei;
  try {
    const bild = await new Promise<HTMLImageElement>((ja, nein) => {
      const i = new Image();
      i.onload = () => ja(i);
      i.onerror = nein;
      i.src = URL.createObjectURL(datei);
    });
    const gross = Math.max(bild.width, bild.height);
    if (gross <= MAX_KANTE) return datei;
    const f = MAX_KANTE / gross;
    const feld = document.createElement('canvas');
    feld.width = Math.round(bild.width * f);
    feld.height = Math.round(bild.height * f);
    feld.getContext('2d')!.drawImage(bild, 0, 0, feld.width, feld.height);
    const klumpen = await new Promise<Blob | null>(
      (ja) => feld.toBlob(ja, 'image/jpeg', JPEG_GUETE));
    if (!klumpen) return datei;
    return new File([klumpen], datei.name.replace(/\.[^.]+$/, '') + '.jpg',
                    { type: 'image/jpeg' });
  } catch {
    return datei;
  }
}

